import createLucideIcon from '../createLucideIcon';

const Flower = createLucideIcon('FlowerIcon', [
  [
    'path',
    {
      d: 'M12 7.5a4.5 4.5 0 1 1 4.5 4.5M12 7.5A4.5 4.5 0 1 0 7.5 12M12 7.5V9m-4.5 3a4.5 4.5 0 1 0 4.5 4.5M7.5 12H9m7.5 0a4.5 4.5 0 1 1-4.5 4.5m4.5-4.5H15m-3 4.5V15',
      key: '51z86h',
    },
  ],
  ['circle', { cx: '12', cy: '12', r: '3', key: '1v7zrd' }],
  ['path', { d: 'm8 16 1.5-1.5', key: 'ce6zph' }],
  ['path', { d: 'M14.5 9.5 16 8', key: '1kzrzb' }],
  ['path', { d: 'm8 8 1.5 1.5', key: '1yv88w' }],
  ['path', { d: 'M14.5 14.5 16 16', key: '12xhjh' }],
]);

export default Flower;
